// toggle dark mode instantly and optionally save to backend
export function toggleDarkMode(persist = true) {
    const html = document.documentElement;
    const current = html.dataset.theme;

    // change instantly
    html.dataset.theme = current === 'business' ? 'corporate' : 'business';

    // save to backend only if persist is true
    if (persist) {
        fetch('/toggle-dark-mode', {
            method: 'POST',
            headers: {'X-Alpine-Request': 'true'}
        });
    }
}

// parse json string to json object or return the object
// used to parse locations string in: CampaignLeadsProvider, CampaignImportLeadsProvider and MapProvider
export function json(data) {
    if (typeof data === 'string') {
        return JSON.parse(data);
    } else if (typeof data === 'object') {
        return data;
    }

    return {};
}

// format seconds to human readable time (e.g. 3600 -> "1 hour", 90 -> "1m 30s")
export function formatDisconnectTimeout(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins >= 60) {
        const hrs = Math.floor(mins / 60);
        const remainMins = mins % 60;
        if (remainMins === 0) {
            return `${hrs} hour${hrs > 1 ? 's' : ''}`;
        }
        return `${hrs}h ${remainMins}m`;
    }
    if (secs === 0) {
        return `${mins} minute${mins > 1 ? 's' : ''}`;
    }
    return `${mins}m ${secs}s`;
}
